module.exports = __webpack_public_path__ + "static/media/or.eb02b0d7.webp";